module.exports = __webpack_public_path__ + "static/zoom-social-eb161be085622bd10d0d05f8b5bd9653.jpg";